import { render, staticRenderFns } from "./DetailsItem.vue?vue&type=template&id=0cc3db6b&scoped=true&"
import script from "./DetailsItem.vue?vue&type=script&lang=js&"
export * from "./DetailsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc3db6b",
  null
  
)

export default component.exports